import React from 'react';
import { connect } from 'react-redux';

import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

export default function NewsLayoutV2(PageComponent) {
    const NewsLayoutV2 = (props) => {
        return (
            <PageComponent
                {...props}
                country={props.country}
                landing={props.landing}
                articles={props.articles}
                selectedArticle={props.selectedArticle}
                categories={props.categories}
                social_section={props.social_section}
                lang={props.lang}
            />
        );
    };
    const mapStateToProps = (state) => {
        return {
            selectedArticle: state.extra?.strapiApi?.selected_article,
            landing: state.extra?.strapiApi?.landing,
            articles: state.extra?.strapiApi?.articles,
            categories: state.extra?.strapiApi?.categories,
            social_section: state.extra?.strapiApi?.social_section,
            lang: state.language.lang,
            country: state.app.country,
        };
    };
    return connect(mapStateToProps)(NotAuthBasePage(NewsLayoutV2));
}
